define(function(require) {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const ViewManager = require('civicsUtils/view_manager');
	const list_view = require('./v_cpv_inspection_results');
	const modal_region = require('civicsUtils/modal_region');
	const tpl = require('./templates/t_lov_inspection_results.hbs');
	const instrument_model = require('civicsModels/instrument_model');
	const inspection_collection = require('civicsCollections/inspections_collection');
	const TimePreferencesCollection = require('civicsCollections/code_definition_collection');
	const InstrumentUtils = require('civicsUtils/instrument_utilities');

	return Marionette.LayoutView.extend({
		events: {
			'click @ui.sortDataButton': 'sortDataClicked',
		},
		template: tpl,
		className: 'all-items inspection-results-div',
		ui: {
			list: '.list-div',
			sortIcon: '.sort-arrow',
			sortDataButton: '[data-sort-type]',
			header: '.header',
			boxHeader: '.inspection-results-header'
		},
		regions: {
			listRegion: '@ui.list',
			modalRegion: {
				selector: 'body .rhythm-modals',
				regionClass: modal_region
			}
		},
		views: {
			listView: {}
		},
		initialize: function(options) {
			this.config = options.config;
			this.cdrType = options.cdrType;
			this.needsActionGrid = options.needsActionGrid === true;
			this.fullCollection = options.list;
			this.title = options.title;
			this.instrumentId = options.instrumentId;
			this.instrumentType = options.instrumentType;
			this.excludeCompleted = options.excludeCompleted;
			this.data = options.data;
			this.config.fromServer = this.config.fromServer ? this.config.fromServer : {};
			this.config.fromServer.instrumentType = this.instrumentType;
			this.timePrefPromise = $.Deferred();
			this.collectionPromise = $.Deferred();
			this.config.isCustomer = this.data && this.data.models && this.data.models.length > 0 ? InstrumentUtils.isCustomer(this.data.models[0].get('ActiveProfiles')) : undefined;

			if(this.config.usesNewConfig){
				if (this.config.isCustomer) {
					this.config.viewOptions = this.config.showCustomer[this.instrumentType];
				} else{
				this.config.viewOptions = this.config.showPublic[this.instrumentType];
				}
	
				if(this.config.useBackOfficeInspectionConfig){
					this.config.captureRequestDateToCallDate = this.config.viewOptions.captureReqDateAsCallDate;
				}
			}
			this.getTimePreferencesCollection();
		},
		onRender: function() {
      this.$el.rhythmCivicsTooltipInit();
      this.$el.rhythmThemeInit();
    },
		onShow: function() {
			var self = this;
			if (this.fullCollection !== undefined) {
				this.collectionPromise.resolve();
				if (this.fullCollection.length > 0) {
					this.showListView();
				}
				else {
					this.ui.header.hide();
				}
			}
			else {
				this.fullCollection = new inspection_collection();
				this.fullCollection.instrumentType = this.instrumentType;
				this.fullCollection.id = this.instrumentId;
				ViewManager.loading(true);
				if (this.data !== undefined) {
					this.fullCollection = this.data;
					this.inspectionCollectionFetched();
					this.collectionPromise.resolve();
				}
				else {
					this.fullCollection.fetch().done(function() {
						self.inspectionCollectionFetched();
					}).always(function() {
						self.collectionPromise.resolve();
					});
				}

			}

			if(this.config.hideHeader) {
				this.ui.boxHeader.hide();
			}

			$.when(this.timePrefPromise, this.collectionPromise).done(function() {
				ViewManager.loading(false);
				self.triggerMethod('insp:collection:fetch:done', this);
				if (self.fullCollection.length > 0) {
					self.showListView();
				}
				else {
					self.ui.header.hide();
				}
			}.bind(this));
		},
		inspectionCollectionFetched: function() {
			this.config.isOwner = undefined;
			if(this.fullCollection != undefined && this.fullCollection.models.length > 0) {
				var activeProfiles = this.fullCollection.models[0].get('ActiveProfiles');
				if(activeProfiles != undefined && activeProfiles.models.length > 0) {
					for (var i = 0; i < activeProfiles.models.length; i++) {
						if (activeProfiles.models[i].get('name') == "Customer") {
							this.config.isOwner = true;
							break;
						}
					}
					if(this.config.isOwner == undefined) {
						this.config.isOwner = false;
					}
				}
			}
		},
		getTimePreferencesCollection: function() {
      var self = this;
      if (typeof this.config.timePreferencesCollection == 'undefined' || this.fullCollection === undefined) {
        this.config.timePreferencesCollection = new TimePreferencesCollection();
        this.config.timePreferencesCollection.moniker = 'Hansen.CDR.' + this.instrumentType + '.TimePreference';
        this.config.timePreferencesCollection.fetch().done().always(function() {
					self.timePrefPromise.resolve();
				});
      } else {
        this.timePrefPromise.resolve();
      }
    },
		showListView: function() {
			var collection = new IpsModelCollection();
			if(this.excludeCompleted) {
				var unresolvedInsp = this.fullCollection.filter(function(model) {
					return model.get('completed') == false;
				});
				collection.set(unresolvedInsp);
			}
			else {
				collection = this.fullCollection;
			}
			this.views.listView = new list_view({
				config: this.config,
				modalRegion: this.modalRegion,
				collection: collection,
				needsActionGrid: this.needsActionGrid,
				instrumentModel: this.instrumentModel,
				usesProviderView: this.usesProviderView
			});
			this.listRegion.show(this.views.listView);
			this.$el.rhythmThemeInit();
		},
		sortDataClicked: function(e) {
			var view = this.views.listView;
			if(view){
				var target = $(e.currentTarget);
				var arrow = target.find('.sort-arrow');
				var sortType = target.data('sort-type');
				var reverseSort = (this.sortType == sortType) && arrow.hasClass('up');
				var otherColumns = this.ui.sortDataButton.not(target);
				otherColumns.removeAttr('aria-sort');
				target.attr('aria-sort', reverseSort ? 'descending': 'ascending');
				this.sortType = sortType;
				this.ui.sortIcon.removeClass('up');
				this.ui.sortIcon.addClass('down');
				if (!reverseSort) arrow.toggleClass('down up');
				this.options.list.sort(sortType, reverseSort ? 'DESC' : 'ASC');
			}
			return false;
		},
		templateHelpers: function() {
			var self = this;
			return {
				needsActionGrid: self.needsActionGrid ? " needs-action" : "",
				totalCount: self.fullCollection === undefined ? 0 : self.fullCollection.length,
				title: self.title,
				showRequestDateField: self.config.globalConfig.usesInspectionRequestDate != "Hide",
				viewName: self.viewName == null ? '' : self.viewName,
			};
		}
	});
});
